import { gsap } from 'gsap';
import './../../libs/clamp/clamp';
import { debounce as _debounce } from 'underscore';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el   : false,
        	main  : null,
        	lines : 2,
        	readmore : true,
        	formatText : false

        	// NOTE :::::::::::::::::::::::::::: for the option readmore we expect to find an internal div .text-to-clamp wher clamp the text !!!!!!
        	/* 
        		<div class="clamp add-read-more" data-lines="6">
        			<div class="text-to-clamp strip-p">the text to clamp</div>
        		</div>

        	*/
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'clamp_read_more';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;
        this.$win           =   $(window);

		// dirty way
		this.$clamp 		=  	window.$clamp;
        this.$text_to_slide =   [];

		if ( this.$el.length > 0 && this.$clamp ){
			this.init();
		}
    }

    init(){

    	if ( this.options.readmore ){
    		this.initClampsReadMore()
    	}
    	else{
    		this.initClamp(this.$el);
    	}
    	this.debounceResize( true );
	}

    initClamp( $text ){
        
        this.clamp = this.$clamp( $text[0], {
			clamp: this.options.lines,
			useNativeClamp: true
    	})

        if ( this.options.readmore ){
            this.$el.css({
                position: 'relative'
            })
            this.$text.after( '<div class="text-to-slide"><div class="sizer">' + this.$text.html() + '</div></div>' );
            this.$text_to_slide = this.$el.find( '.text-to-slide' );
            this.$text.css({
                position: 'absolute'
            });
            this.$text_to_slide.data( 'h', this.$text_to_slide.height() ).height( this.$text.height() ).css({
                overflow: 'hidden',
                opacity: 0
            });
        }

    }

    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => {
                this.onResize();
            }, 117 );
            this.$win.on( 'resize', this._debResize );
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    onResize(){
        if ( this.options.readmore ){
            this.$text_to_slide.data( 'h', this.$text_to_slide.find( '.sizer' ).height() );
        }
    }

    initClampsReadMore( ){

        this.$a_readmore 	= this.$el.find( 'a.read-more' );
        this.$text 			= this.$el.find( '.text-to-clamp' );
        if ( this.$text.length <= 0 ){
        	return;
        } 

        this.addReadMore();

        this.formatText();

		this.initClamp( this.$text );

        this.$a_readmore.on( 'click', (e) => this.onReadMore(e) );
    }

    addReadMore(){
    	// if not present add read-more
        if ( this.$a_readmore.length <= 0 ){
        	this.$el.append( '<a class="read-more" href="#">Read More</a>' );
        	this.$a_readmore = this.$el.find( 'a.read-more' );
        }
    }

    formatText(){
    	if ( ! this.options.formatText ){
    		return;
    	}
        // format, change paragraphs for line-break
        this.$text.data( 'orhtml', this.$text.html() );
        let l = this.$text.find( 'p' ).length;
		this.$text.find('p').each(function ( j ) {
			if ( j < l ){
				$(this).replaceWith($(this).html() + '<br/><br/>');
			}
		    
		});    	
    }

    onReadMore(e){
    	e.preventDefault();
    	this.$el.toggleClass( 'read-less' );
    	$(e.target).text( this.$el.hasClass( 'read-less' ) ? 'Read Less' : 'Read More' );
    	if ( this.$el.hasClass( 'read-less' ) ){
            if ( this.$text_to_slide.length > 0 ){
                gsap.to( this.$text, {opacity:0, duration:0.3 } );
                gsap.to( this.$text_to_slide, {height: this.$text_to_slide.data( 'h'), opacity:1, duration:0.3 } )
            }
            else{
                this.reset( this.$text );
            }
    		
    	}
    	else{
            if ( this.$text_to_slide.length > 0 ){
                gsap.to( this.$text, {opacity:1, duration:0.3 } );
                gsap.to( this.$text_to_slide, {height: this.$text.height(), opacity:0, duration:0.3 } )
            }
            else{
    		  this.initClamp( this.$text );
            }
    	}               
    }

    reset( $element ){
        $element.html( this.clamp.original );
        $element.css({
            'height': '',
            'overflow': 'visible',
            'display': 'block',
            '-webkit-line-clamp': 'none',
            '-webkit-box-orient': 'none'
        })
    }

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
    	if ( this.options.readmore ){
    		if ( this.$text.length > 0 ){
    			this.$a_readmore.off( 'click', (e) => this.onReadMore(e) );
    			this.$a_readmore.remove();
    			this.$text.html( this.$text.data( 'orhtml' ) );
    			this.reset( this.$text );
    		}
            if ( this.$text_to_slide.length > 0 ){
                this.$text_to_slide.remove()
            }
    	}
    	else{
    		this.reset( this.$el );
    	}
        this.debounceResize(false);
    }

}